export class SignersRequiredError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, SignersRequiredError.prototype);
  }
}
